
// Initialize all elements with carousel class.
import bulmaCarousel from 'bulma-carousel/dist/js/bulma-carousel';
document.addEventListener('turbolinks:load', function() {
    bulmaCarousel.attach('#carousel-comments');
});